/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GlobalAttributeDefinitionKey { 
    /**
     * The global attribute definition level. Only BUS_OBJCT_FRMT is currently supported.
     */
    globalAttributeDefinitionLevel: string;
    /**
     * The global attribute definition name to be associated with the level.
     */
    globalAttributeDefinitionName: string;
}
